// Messages for operator/Invoices (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.invoices.head': 'Invoices — Operator',
  'operator.invoices.title': 'Invoices',
  'operator.invoices.subtitle': 'Customer invoicing',
  'operator.invoices.create': 'Create invoice',
  'operator.invoices.edit': 'Edit',
  'operator.invoices.col.invoice': 'Invoice',
  'operator.invoices.col.customer': 'Customer',
  'operator.invoices.col.shipment': 'Shipment',
  'operator.invoices.col.issued': 'Issued',
  'operator.invoices.col.total': 'Total',
  'operator.invoices.col.status': 'Status',
  'operator.invoices.filter.all': 'All',
  'operator.invoices.filter.draft': 'Draft',
  'operator.invoices.filter.issued': 'Issued',
  'operator.invoices.filter.overdue': 'Overdue',
  'operator.invoices.filter.paid': 'Paid',
  'operator.invoices.filter.void': 'Void',
  'operator.invoices.sort.aria': 'Sort invoices',
  'operator.invoices.sort.recent': 'Most recent',
  'operator.invoices.sort.issued': 'Issued date',
  'operator.invoices.sort.due': 'Due date',
  'operator.invoices.sort.total': 'Highest total',
  'operator.invoices.sort.number': 'Invoice no.',
  'operator.invoices.clear': 'Clear',
  'operator.invoices.status_menu_aria': 'Change invoice status',
  'operator.invoices.action.issue': 'Issue invoice',
  'operator.invoices.action.mark_paid': 'Mark as paid',
  'operator.invoices.action.void': 'Void',
  'operator.invoices.action.download': 'Download PDF',
  'operator.invoices.empty.title': 'No invoices yet',
  'operator.invoices.empty.body':
    'Create an invoice for a customer shipment to get started — issue it to notify the customer and make it available for download.',
}

export const zhTW = {
  'operator.invoices.head': '發票 — 操作端',
  'operator.invoices.title': '發票',
  'operator.invoices.subtitle': '客戶開立發票',
  'operator.invoices.create': '建立發票',
  'operator.invoices.edit': '編輯',
  'operator.invoices.col.invoice': '發票',
  'operator.invoices.col.customer': '客戶',
  'operator.invoices.col.shipment': '貨件',
  'operator.invoices.col.issued': '開立日期',
  'operator.invoices.col.total': '總計',
  'operator.invoices.col.status': '狀態',
  'operator.invoices.filter.all': '全部',
  'operator.invoices.filter.draft': '草稿',
  'operator.invoices.filter.issued': '已開立',
  'operator.invoices.filter.overdue': '逾期',
  'operator.invoices.filter.paid': '已付款',
  'operator.invoices.filter.void': '作廢',
  'operator.invoices.sort.aria': '發票排序',
  'operator.invoices.sort.recent': '最新',
  'operator.invoices.sort.issued': '開立日期',
  'operator.invoices.sort.due': '到期日',
  'operator.invoices.sort.total': '金額最高',
  'operator.invoices.sort.number': '發票號碼',
  'operator.invoices.clear': '清除',
  'operator.invoices.status_menu_aria': '變更發票狀態',
  'operator.invoices.action.issue': '開立發票',
  'operator.invoices.action.mark_paid': '標記為已付款',
  'operator.invoices.action.void': '作廢',
  'operator.invoices.action.download': '下載 PDF',
  'operator.invoices.empty.title': '尚無發票',
  'operator.invoices.empty.body': '為客戶貨件建立發票以開始使用——開立後即會通知客戶並提供下載。',
}
